import { useState } from 'react';
import type { DataTableRowEventHandler, DataTableRowEventParams } from '@/components/custom/erp';
import { Group } from '@/types/schemas';

interface UseRowSelectionReturn {
  selectedObj: Group | null;
  selectedRowIndex: string | null;
  handleRowClick: DataTableRowEventHandler<Group>;
  clearSelection: () => void;
}

export const useRowSelection = (): UseRowSelectionReturn => {
  const [selectedObj, setSelectedObj] = useState<Group | null>(null);
  const [selectedRowIndex, setSelectedRowIndex] = useState<string | null>(null);

  const handleRowClick = (params: DataTableRowEventParams<Group>) => {
    setSelectedRowIndex(params.id.toString());
    setSelectedObj(params.row);
  };

  const clearSelection = () => {
    setSelectedObj(null);
    setSelectedRowIndex(null);
  };

  return {
    selectedObj,
    selectedRowIndex,
    handleRowClick,
    clearSelection
  };
};
